// Polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { ColorThemePlugin } from '../services/vuestic-ui'
import store from '../store/index'
import router from '../router/index'
import { VuesticPlugin } from '../services/vuestic-ui/components'
import utils from '../services/utils.js'
import '../i18n/index'
import YmapPlugin from 'vue-yandex-maps'
import VueClipboard from 'vue-clipboard2'
import VueCookies from 'vue-cookies'

import '../metrics'
import '../registerServiceWorker'

import { consoleBuildInfo } from 'vue-cli-plugin-build-info/plugin'

import axios from 'axios';

consoleBuildInfo()

Vue.use(VuesticPlugin)
Vue.use(YmapPlugin)
Vue.use(VueClipboard)
Vue.use(utils)
Vue.use(VueCookies)

Vue.use(ColorThemePlugin, {
  // override colors here.
  // primary: '#EAAF4C',
  // secondary: '#dddddd', //bg e spedito
  // success: 'gold', //confermato
  // info: 'lightgreen', //inserito e title
  // danger: 'red',
  // warning: 'orange',
  // gray: 'gray',
  // dark: 'darkgrey',
})

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  next()
})

router.afterEach((to, from) => {
  store.commit('setLoading', false)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
})

if(store.state.auth.jwt){
  axios.defaults.headers.common['Authorization'] = store.state.auth.jwt;
}
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.baseURL = process.env.VUE_APP_BASEURL ? process.env.VUE_APP_BASEURL : 'http://localhost:3600';


Vue.prototype.$axios = axios;

